import styled from '@emotion/styled'
import theme from '../../../../../styles/theme'
import { InfoSmall600Style } from '../../../../../styles/Text.styles'

export const Container = styled.div`
  padding: 3rem 0rem;
`

export const HeaderTitle = styled.span`
  ${InfoSmall600Style};
  color: ${theme.colors.veryVeryFadedText};
`
